import Footer from "../../Components/Footer";
import "./NewTrt.css";
import Styles from "./LandingPage.module.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AccordionItem from "../../Components/AccordianItem";
import { FAQS_TRT } from "../../Model/FaqModel";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
export default function NewTrt() {
  const ScrollRef = useRef();
  const Navigate = useNavigate();
  const [active, setActive] = useState(null);
  const [MenuActive, setMenuActive] = useState(false);
  const Scroll = () => {
    ScrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    Navigate("/ielts-pte-reality-test-2#RegisterForm");
  };
  const handleToggle = (index) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };

  return (
    <div className="NewTrt">
      <div className={MenuActive ? "overlay active" : "overlay"}></div>
      <header>
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <h1>Testifyi</h1>
            </div>
            <nav className={MenuActive ? "desktop-nav active" : "desktop-nav"}>
              <ul>
                <li>
                  <a href="#about" onClick={() => setMenuActive(false)}>
                    About TRT
                  </a>
                </li>
                <li>
                  <a href="#benefits" onClick={() => setMenuActive(false)}>
                    Benefits
                  </a>
                </li>
                <li>
                  <a href="#locations" onClick={() => setMenuActive(false)}>
                    Test Centers
                  </a>
                </li>
                <li>
                  <a href="#structure" onClick={() => setMenuActive(false)}>
                    Exam Structure
                  </a>
                </li>
              </ul>
            </nav>
            <div
              onClick={() => setMenuActive(!MenuActive)}
              className={
                MenuActive ? "mobile-menu-icon active" : "mobile-menu-icon"
              }
            >
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Testifyi Reality Test</h1>
              <h2>Experience IELTS/PTE in a Real Exam Environment</h2>
              <p>
                Test your readiness before spending ₹18,000 on the actual exam.
                <br />
                Get expert feedback and improve your score.
              </p>
              <div className="highlight-box">
                <span className="price">Just ₹199</span>
                <span className="savings">Save ₹17,801</span>
              </div>
            </div>
            <div className="form-container">
              <h3>Register for TRT</h3>
              <form id="registration-form">
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Name*"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email*"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="city"
                    name="city"
                    placeholder="City*"
                    required
                  />
                </div>
                <div className="form-group phone-group">
                  <div className="country-code">+91</div>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Phone Number*"
                    required
                  />
                </div>
                <div className="form-group-row">
                  <select id="location" name="location" required>
                    <option value="" disabled selected>
                      Select Location
                    </option>
                    <option value="delhi">Delhi</option>
                    <option value="chandigarh">Chandigarh</option>
                  </select>
                  <select id="time-slot" name="time-slot" required>
                    <option value="" disabled selected>
                      Select Time Slot
                    </option>
                    <option value="morning">9:00 AM - 12:00 PM</option>
                    <option value="afternoon">1:00 PM - 4:00 PM</option>
                    <option value="evening">5:00 PM - 8:00 PM</option>
                  </select>
                </div>
                <button type="submit" className="btn-primary-2">
                  Register Now
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="why-trt" id="about">
        <div className="container">
          <h2 className="section-title">Why Take The Reality Test?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <img
                  src="https://images.pexels.com/photos/3769021/pexels-photo-3769021.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Cost-effective"
                  loading="lazy"
                />
              </div>
              <h3>Cost-Effective Practice</h3>
              <p>
                Spend only ₹199 instead of risking ₹18,000 on the real exam
                without knowing your readiness.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <img
                  src="https://images.pexels.com/photos/5428002/pexels-photo-5428002.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Real environment"
                />
              </div>
              <h3>Real Exam Environment</h3>
              <p>
                Experience the pressure and timing of an actual IELTS/PTE exam
                in certified test centers.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <img
                  src="https://images.pexels.com/photos/6238120/pexels-photo-6238120.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Expert feedback"
                  loading="lazy"
                />
              </div>
              <h3>Expert Feedback</h3>
              <p>
                Receive personalized feedback from certified trainers to improve
                your weak areas.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <img
                  src="https://images.pexels.com/photos/5965705/pexels-photo-5965705.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Confidence boost"
                  loading="lazy"
                />
              </div>
              <h3>Confidence Boost</h3>
              <p>
                Build confidence by identifying and addressing your weaknesses
                before the actual exam.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How TRT Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Register</h3>
              <p>
                Fill the form with your details and select your preferred
                location and time slot.
              </p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Attend</h3>
              <p>
                Visit our center in Delhi or Chandigarh on your scheduled date
                and time.
              </p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Take the Test</h3>
              <p>
                Experience all four modules of IELTS/PTE in a real exam-like
                environment.
              </p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Get Feedback</h3>
              <p>
                Receive detailed analysis and improvement tips from our
                certified trainers.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="comparison">
        <div className="container">
          <h2 className="section-title">TRT vs. Actual Exam</h2>
          <div className="comparison-table">
            <div className="comparison-row header">
              <div className="comparison-cell"></div>
              <div className="comparison-cell">Testifyi Reality Test</div>
              <div className="comparison-cell">Actual IELTS/PTE Exam</div>
            </div>
            <div className="comparison-row">
              <div className="comparison-cell feature">Cost</div>
              <div className="comparison-cell">₹199 only</div>
              <div className="comparison-cell">₹18,000</div>
            </div>
            <div className="comparison-row">
              <div className="comparison-cell feature">Test Environment</div>
              <div className="comparison-cell">Identical to actual exam</div>
              <div className="comparison-cell">Standard exam environment</div>
            </div>
            <div className="comparison-row">
              <div className="comparison-cell feature">Feedback</div>
              <div className="comparison-cell">
                Detailed personalized feedback
              </div>
              <div className="comparison-cell">
                Only scores, no detailed feedback
              </div>
            </div>
            <div className="comparison-row">
              <div className="comparison-cell feature">Risk</div>
              <div className="comparison-cell">
                No risk, practice opportunity
              </div>
              <div className="comparison-cell">High risk if unprepared</div>
            </div>
            <div className="comparison-row">
              <div className="comparison-cell feature">Improvement Chance</div>
              <div className="comparison-cell">Yes, before actual exam</div>
              <div className="comparison-cell">
                Need to pay again for retake
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="test-structure" id="structure">
        <div className="container">
          <h2 className="section-title">Test Structure</h2>
          <div className="test-modules">
            <div className="module">
              <h3>Listening</h3>
              <p>4 sections, 40 questions</p>
              <p>30 minutes + 10 minutes transfer time</p>
            </div>
            <div className="module">
              <h3>Reading</h3>
              <p>3 sections, 40 questions</p>
              <p>60 minutes</p>
            </div>
            <div className="module">
              <h3>Writing</h3>
              <p>2 tasks (150 and 250 words)</p>
              <p>60 minutes</p>
            </div>
            <div className="module">
              <h3>Speaking</h3>
              <p>3-part face-to-face interview</p>
              <p>11-14 minutes</p>
            </div>
          </div>
          <p className="note">
            *The structure is identical to the actual IELTS Academic/General
            Training test format.
          </p>
        </div>
      </section>

      <section className="locations" id="locations">
        <div className="container">
          <h2 className="section-title">Our Test Centers</h2>
          {/* <div className="centers">
            <div className="center">
              <h3>Delhi Center</h3>
              <p>Testifyi Learning Center</p>
              <p>123 Connaught Place, New Delhi</p>
              <p>Contact: +91 98765 43210</p>
            </div>
            <div className="center">
              <h3>Chandigarh Center</h3>
              <p>Testifyi Education Hub</p>
              <p>456 Sector 17, Chandigarh</p>
              <p>Contact: +91 98765 43211</p>
            </div>
          </div> */}
          <div className={Styles.EventDetails}>
            <div>
              <h4>Delhi</h4>
              <p className={Styles.Date}>
                <span style={{ color: "#0b3eff" }}>
                  <FaCalendarAlt />
                </span>{" "}
                <span>
                  {" "}
                  10<sup>th</sup> May 2025 (Saturday)
                </span>
              </p>
              <div className={Styles.Slots}>
                <div className={Styles.Slot}>
                  <h3>Slot-1</h3>
                  <p>10:30 AM to 1:30 PM</p>
                </div>
                <div className={Styles.Slot}>
                  <h3>Slot-2</h3>
                  <p>2:00 PM to 5:00 PM</p>
                </div>
              </div>
              <p className={Styles.location}>
                <span style={{ color: "#0b3eff" }}>
                  <FaMapMarkerAlt />
                </span>{" "}
                1409-1412, 14th Floor, 38, Ansal Tower, Nehru Place, New Delhi,
                Delhi 110019
              </p>
            </div>
            <div>
              <h4>Chandigarh</h4>
              <p className={Styles.Date}>
                {" "}
                <span style={{ color: "#0b3eff" }}>
                  <FaCalendarAlt />
                </span>{" "}
                <span>
                  10<sup>th</sup> May 2025 (Saturday){" "}
                </span>
              </p>
              <div className={Styles.Slots}>
                <div className={Styles.Slot}>
                  <h3>Slot-1</h3>
                  <p>10:30 AM to 1:30 PM</p>
                </div>
                <div className={Styles.Slot}>
                  <h3>Slot-2</h3>
                  <p>
                    <span></span> 2:00 PM to 5:00 PM
                  </p>
                </div>
              </div>
              <p className={Styles.location}>
                <span style={{ color: "#0b3eff" }}>
                  <FaMapMarkerAlt />
                </span>{" "}
                SCO 491, First Floor, above Airtel Store, sector 35C,
                Chandigarh, 160022
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="testimonials">
        <div className="container">
          <h2 className="section-title">What Our Students Say</h2>
          <div className="testimonial-slider">
            <div className="testimonial">
              <div className="student-photo">
                <img
                  src="https://images.pexels.com/photos/3771089/pexels-photo-3771089.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Student"
                />
              </div>
              <p className="quote">
                "Taking the TRT was the best decision I made. It helped me
                identify my weaknesses in Speaking, and after working on them, I
                scored 7.5 in the actual IELTS exam!"
              </p>
              <p className="student-name">Raj Sharma</p>
              <p className="student-score">IELTS: 7.5 Overall</p>
            </div>
            <div className="testimonial">
              <div className="student-photo">
                <img
                  src="https://images.pexels.com/photos/3756679/pexels-photo-3756679.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Student"
                />
              </div>
              <p className="quote">
                "The reality test environment was exactly like the actual PTE
                exam. The feedback session helped me improve my speaking fluency
                significantly."
              </p>
              <p className="student-name">Priya Verma</p>
              <p className="student-score">PTE: 79 Overall</p>
            </div>
            <div className="testimonial">
              <div className="student-photo">
                <img
                  src="https://images.pexels.com/photos/5212317/pexels-photo-5212317.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Student"
                />
              </div>
              <p className="quote">
                "I was nervous about wasting ₹18,000 on the IELTS exam. The TRT
                helped me prepare mentally and technically for just ₹199. Best
                investment ever!"
              </p>
              <p className="student-name">Ankit Patel</p>
              <p className="student-score">IELTS: 8.0 Overall</p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="testimonials">
        <div className="container">
          <h2 className="section-title">What Our Students Say</h2>
          <div className="testimonials-container">
            <div className="testimonials-track">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <div className="quote-icon">❝</div>
                  <p className="testimonial-text">
                    Taking the TRT was the best decision I made. It helped me
                    identify my weaknesses in Speaking, and after working on
                    them, I scored 7.5 in the actual IELTS exam!
                  </p>
                  <div className="student-info">
                    <div className="student-image">
                      <img
                        src="https://images.pexels.com/photos/3771089/pexels-photo-3771089.jpeg"
                        alt="Student"
                      />
                    </div>
                    <div className="student-details">
                      <h3>Raj Sharma</h3>
                      <p className="score">IELTS: 7.5 Overall</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <div className="quote-icon">❝</div>
                  <p className="testimonial-text">
                    The reality test environment was exactly like the actual PTE
                    exam. The feedback session helped me improve my speaking
                    fluency significantly.
                  </p>
                  <div className="student-info">
                    <div className="student-image">
                      <img
                        src="https://images.pexels.com/photos/3756679/pexels-photo-3756679.jpeg"
                        alt="Student"
                      />
                    </div>
                    <div className="student-details">
                      <h3>Priya Verma</h3>
                      <p className="score">PTE: 79 Overall</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="testimonial-card">
                <div className="testimonial-content">
                  <div className="quote-icon">❝</div>
                  <p className="testimonial-text">
                    I was nervous about wasting ₹18,000 on the IELTS exam. The
                    TRT helped me prepare mentally and technically for just
                    ₹199. Best investment ever!
                  </p>
                  <div className="student-info">
                    <div className="student-image">
                      <img
                        src="https://images.pexels.com/photos/5212317/pexels-photo-5212317.jpeg"
                        alt="Student"
                      />
                    </div>
                    <div className="student-details">
                      <h3>Ankit Patel</h3>
                      <p className="score">IELTS: 8.0 Overall</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-indicator">
            <div className="scroll-dot active"></div>
            <div className="scroll-dot"></div>
            <div className="scroll-dot"></div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container">
          <h2>Don't Risk ₹18,000. Start with ₹199.</h2>
          <p>Book your Testifyi Reality Test today and prepare for success!</p>
          <a href="#registration-form" className="btn-primary">
            Register Now
          </a>
        </div>
      </section>

      {/* FAQs satrt */}

      <section style={{ background: "#ffffff" }} className="Faqs">
        <div className={Styles.Margin2}>
          <div className="container-fluid mt-5 mb-5">
            <div className="card-body_Faq">
              <div className={Styles.Form_Heading}>
                <h1 className="">
                  Frequently Asked{" "}
                  <span style={{ color: "#0b3eff" }}>Questions</span>
                </h1>
                <p style={{ textAlign: "center" }}>
                  Got Questions? We’ve Got Answers!
                </p>
              </div>
              <div className="FAQ_ALL">
                {FAQS_TRT.map((faq, index) => {
                  return (
                    <AccordionItem
                      key={index}
                      active={active}
                      handleToggle={handleToggle}
                      faq={faq}
                    />
                  );
                })}
              </div>
              {/* <div className={Styles.Center}>
                <button className={Styles.ActionBtn} onClick={() => Scroll()}>
                  Join the Test Today
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* FAQs end */}

      {/* <section className="faq">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-items">
            <div className="faq-item">
              <h3>What is the Testifyi Reality Test (TRT)?</h3>
              <p>
                The TRT is a mock test that simulates the actual IELTS/PTE exam
                environment, helping you assess your readiness before spending
                ₹18,000 on the real test.
              </p>
            </div>
            <div className="faq-item">
              <h3>How is TRT different from regular mock tests?</h3>
              <p>
                TRT is conducted in certified centers with the same timing,
                pressure, and environment as the actual exam, plus you get
                personalized feedback from certified trainers.
              </p>
            </div>
            <div className="faq-item">
              <h3>Do I need to bring anything for the test?</h3>
              <p>
                Just bring a valid ID proof. All materials required for the test
                will be provided at the center.
              </p>
            </div>
            <div className="faq-item">
              <h3>How long will the feedback session be?</h3>
              <p>
                The feedback session typically lasts for 20-30 minutes where our
                expert trainers analyze your performance and provide improvement
                suggestions.
              </p>
            </div>
            <div className="faq-item">
              <h3>Can I reschedule my TRT?</h3>
              <p>
                Yes, you can reschedule your TRT up to 48 hours before your
                scheduled slot without any additional charges.
              </p>
            </div>
          </div>
        </div>
      </section> */}
      <Footer />
    </div>
  );
}
